import { Pipe, PipeTransform } from '@angular/core';
import { UtilService } from '@core-services/util.service';
@Pipe({
    name: 'dateTransform',
    standalone: false
})
export class DateTransformPipe implements PipeTransform {
  constructor(private utilService: UtilService) {}
  transform(value: any, args: any[]): any {
    const formattedDate = this.utilService.formatDate(value);
    return formattedDate;
  }
}
